import { ReactComponent as Calendar } from '@assets/svg/calendar.svg';
import React from 'react';
import './styles.scss';
import { DetailsContainer } from '@ui-modules';

interface IProps {
  date: string;
  isDeadlineReached: boolean;
  days: string;
}

const SubmissionDeadline = ({ date, isDeadlineReached, days }: IProps) => {
  const Component = (
    <div className="submission-container">
      <div className="date-info">
        <span className={`indicator ${!isDeadlineReached && 'green'}`} />
        <div>
          <p>{date}</p>
          <p className="subtext">{isDeadlineReached ? 'deadline reached' : `${days}`}</p>
        </div>
      </div>
      <Calendar className="calendar-icon" />
    </div>
  );

  return (
    <DetailsContainer
      items={[
        {
          content: Component,
          label: 'QUOTATIONS SUBMISSION DEADLINE',
        },
      ]}
    />
  );
};

export default SubmissionDeadline;
